import { CartesianPosition, HexProperties, Position } from '@wareena/game-algorithms';
import UnitCounter, { UnitProps } from '@wareena/grid-battles-ui/game/unit/UnitCounter';

function calcUnitOrigin(center: CartesianPosition, counterSize: number) {
    return {
        x: center.x - counterSize / 2,
        y: center.y - counterSize / 2,
    };
}

interface UnitPropsWithPosition extends UnitProps {
    position: Position;
}

function UnitLayer({
    units,
    hexProperties,
}: {
    units: UnitPropsWithPosition[];
    hexProperties: HexProperties;
}) {
    const counterSize = hexProperties.hasFlatTop
        ? hexProperties.height / 1.5
        : hexProperties.width / 1.5;

    const counters = units.map((unit) => {
        const centerPos = hexProperties.calculateCenterPos(unit.position.column, unit.position.row);

        const unitOriginPoint = calcUnitOrigin(centerPos, counterSize);

        return (
            <UnitCounter
                key={`unit-${unit.label}-${unit.position.column}-${unit.position.row}`}
                origin={unitOriginPoint}
                counterSize={counterSize}
                unit={unit}
            />
        );
    });

    return <g>{counters}</g>;
}

export default UnitLayer;
